export const GET_RESULTS_REQUEST = "GET_RESULTS_REQUEST";
export const GET_RESULTS_SUCCESS = "GET_RESULTS_SUCCESS";
export const GET_RESULTS_ERROR = "GET_RESULTS_ERROR";
export const GET_RAG_RESULT_REQUEST = "GET_RAG_RESULT_REQUEST";
export const GET_RAG_RESULT_SUCCESS = "GET_RAG_RESULT_SUCCESS";
export const GET_RAG_RESULT_ERROR = "GET_RAG_RESULT_ERROR";
export const GET_RAG_VISIBILITY = "GET_RAG_VISIBILITY";
export const SET_RAG_VISIBILITY = "SET_RAG_VISIBILITY";
export const FILTER_RESULTS_REQUEST = "FILTER_RESULTS_REQUEST";
export const FILTER_RESULTS_SUCCESS = "FILTER_RESULTS_SUCCESS";
export const FILTER_RESULTS_ERROR = "FILTER_RESULTS_ERROR";
export const MORE_RESULTS_REQUEST = "MORE_RESULTS_REQUEST";
export const MORE_RESULTS_SUCCESS = "MORE_RESULTS_SUCCESS";
export const MORE_RESULTS_ERROR = "MORE_RESULTS_ERROR";
export const CLEAR_RESULTS_NOTIFICATION = "CLEAR_RESULTS_NOTIFICATION";
export const CLEAR_SHOULD_SCROLL_TO_TOP = "CLEAR_SHOULD_SCROLL_TO_TOP";
export const CLEAR_FILTER_RESULTS_ERROR = "CLEAR_FILTER_RESULTS_ERROR";
